import React, { useEffect } from "react";
import {
    Box,
    Tab,
    Tabs,
    Typography,
    makeStyles,
    Divider,
    useTheme,
    useMediaQuery,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";

import SetupOffices from "./SetupOffices";
import SetupModules from "./SetupModules";
import SetupDivisions from "./SetupDivisions";
import SetupSequence from "./SetupSequence";
import SetupAccessRights from "./SetupAccessRights";
import SetupGroups from "./SetupGroups";

import { getUsers } from "../../../actions/userActions";
import { getDivisions } from "../../../actions/divisionActions";
import { getAllModules } from "../../../actions/moduleAction";
import { getOffices } from "../../../actions/officeActions";
import { getAllSequences } from "../../../actions/sequenceAction";
import { getAllAccessRights } from "../../../actions/accessRightsActions";
import { getAllGroups } from "../../../actions/groupsAction";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
    },
    title: {
        display: "block",
        fontSize: 16,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontFamily: "Rubik",
        fontWeight: "bold"
    },
    title2: {
        display: "block",
        fontSize: 14,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontFamily: "Rubik",
    },
}));

const AdminSetup = () => {
    const [value, setValue] = React.useState(0);
    const classes = useStyles();
    const dispatch = useDispatch();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down("sm"));

    const { offices, loading } = useSelector((state) => state.office);
    const { divisions, error } = useSelector((state) => state.division);
    const { modules } = useSelector((state) => state.module);
    const { sequences } = useSelector((state) => state.sequence);
    const { users } = useSelector((state) => state.user);
    const { accessRights } = useSelector((state) => state.accessRights);
    const { groups } = useSelector((state) => state.groups);

    useEffect(() => {
        dispatch(getDivisions());
        dispatch(getUsers())
        dispatch(getAllModules());
        dispatch(getOffices());
        dispatch(getAllSequences());
        dispatch(getAllAccessRights());
        dispatch(getAllGroups());
    }, [dispatch]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className={classes.root}>
            <Typography variant="overline" className={classes.title} gutterBottom>
                Admin Setup
            </Typography>

            <Tabs
                value={value}
                onChange={handleChange}
                aria-label="simple tabs example"
                variant={matches ? "scrollable" : "fullWidth"}
                scrollButtons={matches ? "on" : "off"}
            >
                <Tab
                    label={
                        <Typography className={classes.title2} gutterBottom>
                            Offices 
                        </Typography>
                    }
                    fullWidth
                    {...a11yProps(0)}
                />
                <Tab
                    label={
                        <Typography className={classes.title2} gutterBottom>
                            Divisions/Units
                        </Typography>
                    }
                    fullWidth
                    {...a11yProps(1)}
                />
                <Tab
                    label={
                        <Typography className={classes.title2} gutterBottom>
                            Modules
                        </Typography>
                    }
                    fullWidth
                    {...a11yProps(2)}
                />
                <Tab
                    label={
                        <Typography className={classes.title2} gutterBottom>
                            Sequence
                        </Typography>
                    }
                    fullWidth
                    {...a11yProps(3)}
                />
                <Tab
                    label={
                        <Typography className={classes.title2} gutterBottom>
                            Permissions
                        </Typography>
                    }
                    fullWidth
                    {...a11yProps(4)}
                />
                <Tab
                    label={
                        <Typography className={classes.title2} gutterBottom>
                            Access Rights
                        </Typography>
                    }
                    fullWidth
                    {...a11yProps(5)}
                />
                <Tab
                    label={
                        <Typography className={classes.title2} gutterBottom>
                            Groups
                        </Typography>
                    }
                    fullWidth
                    {...a11yProps(6)}
                />
            </Tabs>
            
            <Divider />

            <TabPanel value={value} index={0}>
                <SetupOffices {...{ loading, offices }} />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <SetupDivisions {...{ loading, users, divisions, error }} />
            </TabPanel>
            <TabPanel value={value} index={2}>
                <SetupModules {...{ loading, modules }} />
            </TabPanel>
            <TabPanel value={value} index={3}>
                <SetupSequence {...{ loading, sequences }} />
            </TabPanel>
            <TabPanel value={value} index={4}>
                
            </TabPanel>
            <TabPanel value={value} index={5}>
                <SetupAccessRights {...{ loading, accessRights }} />
            </TabPanel>
            <TabPanel value={value} index={6}>
                <SetupGroups {...{ loading, groups }} />
            </TabPanel>
        </div>
    );
};

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

export default AdminSetup;
